export const usCities = [
  "Abilene",
  "Akron",
  "Albany",
  "Albuquerque",
  "Alexandria",
  "Allen",
  "Allentown",
  "Amarillo",
  "Amherst",
  "Anaheim",
  "Anchorage",
  "Ann Arbor",
  "AnnArbor",
  "Annapolis",
  "Antioch",
  "Appleton",
  "Arlington",
  "Arvada",
  "Ashburn",
  "Asheville",
  "Athens",
  "Atlanta",
  "Atlantic City",
  "AtlanticCity",
  "Augusta",
  "Aurora",
  "Austin",
  "Avondale",
  "Bakersfield",
  "Baltimore",
  "Barnstable Town",
  "BarnstableTown",
  "Baton Rouge",
  "BatonRouge",
  "Beaumont",
  "Bellevue",
  "Bellingham",
  "Bend",
  "Berkeley",
  "Billings",
  "Binghamton",
  "Birmingham",
  "Bismarck",
  "Bloomington",
  "Boardman",
  "Boise",
  "Bonita Springs",
  "BonitaSprings",
  "Boston",
  "Boulder",
  "Brandon",
  "Bremerton",
  "Bridgeport",
  "Broken Arrow",
  "BrokenArrow",
  "Bronx",
  "Brookhaven",
  "Brooklyn",
  "Brownsville",
  "Buffalo",
  "Burbank",
  "Burlington",
  "Cambridge",
  "Canton",
  "Cape Coral",
  "CapeCoral",
  "Carlsbad",
  "Carrollton",
  "Carson City",
  "CarsonCity",
  "Cary",
  "Cedar Rapids",
  "CedarRapids",
  "Centennial",
  "Champaign",
  "Chandler",
  "Charleston",
  "Charlotte",
  "Charlottesville",
  "Chattanooga",
  "Chesapeake",
  "Cheyenne",
  "Chicago",
  "Chico",
  "Chula Vista",
  "ChulaVista",
  "Cincinnati",
  "Clarksville",
  "Clearwater",
  "Cleveland",
  "Clovis",
  "Coeur d'Alene",
  "Coeurd'Alene",
  "College Station",
  "CollegeStation",
  "Collegeville",
  "Colorado Springs",
  "ColoradoSprings",
  "Columbia",
  "Columbus",
  "Concord",
  "Coral Springs",
  "CoralSprings",
  "Corona",
  "Corpus Christi",
  "CorpusChristi",
  "Costa Mesa",
  "CostaMesa",
  "Dallas",
  "Daly City",
  "DalyCity",
  "Danbury",
  "Davenport",
  "Davie",
  "Dayton",
  "DC",
  "D\\.C",
  "Deltona",
  "Denton",
  "Denver",
  "Des Moines",
  "DesMoines",
  "Detroit",
  "District of Columbia",
  "District ofColumbia",
  "Districtof Columbia",
  "DistrictofColumbia",
  "Dover",
  "Downey",
  "Duluth",
  "Durham",
  "East Los Angeles",
  "East LosAngeles",
  "EastLos Angeles",
  "EastLosAngeles",
  "Eau Claire",
  "EauClaire",
  "Edison",
  "El Cajon",
  "ElCajon",
  "El Centro",
  "ElCentro",
  "El Monte",
  "ElMonte",
  "El Paso",
  "ElPaso",
  "Elgin",
  "Elizabeth",
  "Elk Grove",
  "ElkGrove",
  "Elkhart",
  "Enterprise",
  "Erie",
  "Escondido",
  "Eugene",
  "Evansville",
  "Everett",
  "Fairfield",
  "Fargo",
  "Fayetteville",
  "Flint",
  "Fontana",
  "Ft\\. Collins",
  "Fort Collins",
  "FortCollins",
  "Ft\\. Lauderdale",
  "Fort Lauderdale",
  "FortLauderdale",
  "Ft\\. Smith",
  "Fort Smith",
  "FortSmith",
  "Ft\\. Wayne",
  "Fort Wayne",
  "FortWayne",
  "Ft\\. Worth",
  "Fort Worth",
  "FortWorth",
  "Frankfort",
  "Frederick",
  "Fredericksburg",
  "Fremont",
  "Fresno",
  "Frisco",
  "Fullerton",
  "Gainesville",
  "Garden Grove",
  "GardenGrove",
  "Garland",
  "Gastonia",
  "Gilbert",
  "Gilroy",
  "Glendale",
  "Grand Junction",
  "GrandJunction",
  "Grand Prairie",
  "GrandPrairie",
  "Grand Rapids",
  "GrandRapids",
  "Greeley",
  "Green Bay",
  "GreenBay",
  "Greensboro",
  "Greenville",
  "Gresham",
  "Gulfport",
  "Hagerstown",
  "Hampton",
  "Harlingen",
  "Harrisburg",
  "Hartford",
  "Hayward",
  "Helena",
  "Hemet",
  "Henderson",
  "Hialeah",
  "Hickory",
  "High Point",
  "HighPoint",
  "Highlands Ranch",
  "HighlandsRanch",
  "Hillsboro",
  "Holland",
  "Hollywood",
  "Honolulu",
  "Houma",
  "Houston",
  "Huntington",
  "Huntington Beach",
  "HuntingtonBeach",
  "Huntsville",
  "Independence",
  "Indianapolis",
  "Indio",
  "Inglewood",
  "Iowa City",
  "IowaCity",
  "Irvine",
  "Irving",
  "Islip",
  "Jackson",
  "Jacksonville",
  "Jefferson City",
  "JeffersonCity",
  "Jersey City",
  "JerseyCity",
  "Johnson City",
  "JohnsonCity",
  "Joliet",
  "Juneau",
  "Jurupa Valley",
  "JurupaValley",
  "Kalamazoo",
  "Kansas City",
  "KansasCity",
  "Kerrville",
  "Kennewick",
  "Kenosha",
  "Kent",
  "Killeen",
  "Kingsport",
  "Kissimmee",
  "Knoxville",
  "La Crosse",
  "LaCrosse",
  "Lafayette",
  "Lake Charles",
  "LakeCharles",
  "Lakeland",
  "Lakewood",
  "Lancaster",
  "Lansing",
  "Laredo",
  "Las Cruces",
  "LasCruces",
  "Las Vegas",
  "LasVegas",
  "League City",
  "LeagueCity",
  "Leesburg",
  "Lehigh Acres",
  "LehighAcres",
  "Leominster",
  "Lewisville",
  "Lexington",
  "Ligonier",
  "Lincoln",
  "Little Rock",
  "LittleRock",
  "Logan",
  "Long Beach",
  "LongBeach",
  "Longview",
  "Lorain",
  "Los Angeles",
  "LosAngeles",
  "Louisville",
  "Lowell",
  "Lubbock",
  "Lynchburg",
  "Macon",
  "Madison",
  "Manchester",
  "Manhattan",
  "Marysville",
  "Mauldin",
  "McAllen",
  "McKinney",
  "Medford",
  "Memphis",
  "Merced",
  "Mesa",
  "Mesquite",
  "Metairie",
  "Miami",
  "Miami Gardens",
  "MiamiGardens",
  "Midland",
  "Milwaukee",
  "Minneapolis",
  "Miramar",
  "Mission Viejo",
  "MissionViejo",
  "Modesto",
  "Monroe",
  "Montgomery",
  "Montpelier",
  "Moreno Valley",
  "MorenoValley",
  "Murfreesboro",
  "Murrieta",
  "Muskegon",
  "Myrtle Beach",
  "MyrtleBeach",
  "Nampa",
  "Naperville",
  "Nashua",
  "Nashville",
  "New Bedford",
  "NewBedford",
  "New Haven",
  "NewHaven",
  "New Orleans",
  "NewOrleans",
  "New York",
  "NewYork",
  "Newark",
  "Newport News",
  "NewportNews",
  "Norfolk",
  "Norman",
  "Northbrook",
  "North Charleston",
  "NorthCharleston",
  "Northfield",
  "North Hempstead",
  "NorthHempstead",
  "North Las Vegas",
  "North LasVegas",
  "NorthLas Vegas",
  "NorthLasVegas",
  "North Port",
  "NorthPort",
  "Norwalk",
  "Norwich",
  "Oakland",
  "Ocala",
  "Oceanside",
  "Odessa",
  "Ogden",
  "Oklahoma City",
  "OklahomaCity",
  "Olathe",
  "Olympia",
  "Omaha",
  "Ontario",
  "Orange",
  "Orlando",
  "Overland Park",
  "OverlandPark",
  "Oxnard",
  "Oyster Bay",
  "OysterBay",
  "Palm Bay",
  "PalmBay",
  "Palm Coast",
  "PalmCoast",
  "Palmdale",
  "Palmetto",
  "Panama City",
  "PanamaCity",
  "Paradise",
  "Pasadena",
  "Paterson",
  "Peaberry",
  "Pearland",
  "Pembroke Pines",
  "PembrokePines",
  "Pensacola",
  "Peoria",
  "Philadelphia",
  "Phoenix",
  "Pierre",
  "Pittsburgh",
  "Plano",
  "Pomona",
  "Pompano Beach",
  "PompanoBeach",
  "Port Arthur",
  "PortArthur",
  "Port Saint Lucie",
  "Port SaintLucie",
  "PortSaint Lucie",
  "PortSaintLucie",
  "Port St\\. Lucie",
  "Port St\\.Lucie",
  "PortSt\\. Lucie",
  "PortSt\\.Lucie",
  "Port St Lucie",
  "Port StLucie",
  "PortSt Lucie",
  "PortStLucie",
  "Portland",
  "Pottstown",
  "Poughkeepsie",
  "Providence",
  "Provo",
  "Pueblo",
  "Queens",
  "Racine",
  "Raleigh",
  "Ramapo",
  "Rancho Cucamonga",
  "RanchoCucamonga",
  "Reading",
  "Redding",
  "Reno",
  "Renton",
  "Rialto",
  "Richardson",
  "Richmond",
  "Riverside",
  "Roanoke",
  "Rochester",
  "Rock Hill",
  "RockHill",
  "Rockford",
  "Roseburg",
  "Roseville",
  "Round Lake Beach",
  "Round LakeBeach",
  "RoundLake Beach",
  "RoundLakeBeach",
  "Round Rock",
  "RoundRock",
  "Sacramento",
  "Saginaw",
  "Saint Paul",
  "SaintPaul",
  "Salem",
  "Salinas",
  "Salisbury",
  "Salt Lake City",
  "Salt LakeCity",
  "SaltLake City",
  "SaltLakeCity",
  "San Antonio",
  "SanAntonio",
  "San Bernardino",
  "SanBernardino",
  "San Buenaventura",
  "SanBuenaventura",
  "San Diego",
  "SanDiego",
  "San Francisco",
  "SanFrancisco",
  "San Jose",
  "SanJose",
  "San Mateo",
  "SanMateo",
  "Sandy Springs",
  "SandySprings",
  "Santa Ana",
  "SantaAna",
  "Santa Barbara",
  "SantaBarbara",
  "Santa Clara",
  "SantaClara",
  "Santa Clarita",
  "SantaClarita",
  "Santa Cruz",
  "SantaCruz",
  "Santa Fe",
  "SantaFe",
  "Santa Maria",
  "SantaMaria",
  "Santa Rosa",
  "SantaRosa",
  "Sarasota",
  "Savannah",
  "Scottsdale",
  "Scranton",
  "Seaside",
  "Seattle",
  "Shreveport",
  "Silverdale",
  "Simi Valley",
  "SimiValley",
  "Sioux City",
  "SiouxCity",
  "Sioux Falls",
  "SiouxFalls",
  "Smithtown",
  "South Bend",
  "SouthBend",
  "South Lyon",
  "SouthLyon",
  "Sparks",
  "Spartanburg",
  "Spokane",
  "Spring Hill",
  "SpringHill",
  "Spring Valley",
  "SpringValley",
  "Springfield",
  "Saint Cloud",
  "SaintCloud",
  "Saint George",
  "SaintGeorge",
  "Saint Louis",
  "SaintLouis",
  "Saint Paul",
  "SaintPaul",
  "Saint Petersburg",
  "SaintPetersburg",
  "St\\. Cloud",
  "St\\.Cloud",
  "St Cloud",
  "StCloud",
  "St\\. George",
  "St\\.George",
  "St George",
  "StGeorge",
  "St\\. Louis",
  "St\\.Louis",
  "St Louis",
  "StLouis",
  "St\\. Paul",
  "St\\.Paul",
  "St Paul",
  "StPaul",
  "St\\. Petersburg",
  "St\\.Petersburg",
  "St Petersburg",
  "StPetersburg",
  "Stamford",
  "Staten Island",
  "StatenIsland",
  "Sterling Heights",
  "SterlingHeights",
  "Stockton",
  "Sunnyvale",
  "Sunrise Manor",
  "SunriseManor",
  "Surprise",
  "Syracuse",
  "Tacoma",
  "Tallahassee",
  "Tampa",
  "Temecula",
  "Tempe",
  "Temple",
  "Texas City",
  "TexasCity",
  "The Woodlands",
  "TheWoodlands",
  "Thornton",
  "Thousand Oaks",
  "ThousandOaks",
  "Toledo",
  "Topeka",
  "Torrance",
  "Trenton",
  "Tucson",
  "Tulsa",
  "Turlock",
  "Tuscaloosa",
  "Tyler",
  "Utica",
  "Vacaville",
  "Vallejo",
  "Valparaiso",
  "Vancouver",
  "Victorville",
  "Virginia Beach",
  "VirginiaBeach",
  "Visalia",
  "Vista",
  "Waco",
  "Warner Robins",
  "WarnerRobins",
  "Warren",
  "Washington DC",
  "WashingtonDC",
  "Washington D\\.C",
  "WashingtonD\\.C",
  "Waterbury",
  "Waterloo",
  "West Covina",
  "WestCovina",
  "West Jordan",
  "WestJordan",
  "West Palm Beach",
  "West PalmBeach",
  "WestPalm Beach",
  "WestPalmBeach",
  "West Valley City",
  "West ValleyCity",
  "WestValley City",
  "WestValleyCity",
  "Westminster",
  "Wichita",
  "Wilmington",
  "Winston-Salem",
  "Winter Haven",
  "WinterHaven",
  "Woodbridge",
  "Worcester",
  "Yakima",
  "Yonkers",
  "York",
  "Youngstown",
  "Yuba City",
  "YubaCity",
  "Yuma",
];
